/// <amd-module name="Widgets/Configs/Common/OpStoreTeamsQuery" />
import { batchGet } from "Reporting/Common/BatchQuery";
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { WebApiTeam } from "Tfs/Platform/Contracts/Core";
import { getCoreClient } from "Tfs/Platform/RestClient/Core";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

/** Makes a query for teams against the operational store. Only scoped to project */
export class OpStoreTeamsQuery implements ICacheableQuery<WebApiTeam[]> {
    public static onProject(projectId: string): OpStoreTeamsQuery {
        return new OpStoreTeamsQuery(projectId);
    }

    private constructor(private projectId: string) {}

    public getKey(): string {
        return "TeamsQuery-" + this.projectId;
    }

    public async runQuery(pageContext: IVssPageContext): Promise<WebApiTeam[]> {
        const client = getCoreClient(pageContext);
        const getPage = async (top: number, skip: number) => {
            const justMine = false;
            return client.getTeams(this.projectId, justMine, top, skip);
        };

        const teams = await batchGet(getPage);
        return teams.sort((a, b) => {
            return localeIgnoreCaseComparer(a.name, b.name);
        });
    }
}

/**
 * Used to convert the results of this query into IListBoxItem[].
 * We avoid referencing IListBoxItem directly to avoid taking a dependency on that contribution. */
export function convertToListBoxItems(teams: WebApiTeam[]): Array<{ id: string; text: string; data: WebApiTeam }> {
    return teams.map(team => {
        return {
            data: team,
            id: team.id,
            text: team.name
        };
    });
}
